import React from 'react';

export default function Spinner({ size = 6, className = '' }) {
  return (
    <svg
      className={`animate-spin text-primary-600 ${className}`}
      style={{ width: `${size * 4}px`, height: `${size * 4}px` }}
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
    </svg>
  );
}

export function FullPageSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-50">
      <Spinner size={8} />
    </div>
  );
}
